import { Breakpoint, breakpoints } from './constants';

export interface QueryOptions {
  maxOnly?: boolean;
  minOnly?: boolean;
}

const breakpointQuerySettingsMap = new Map([
  [Breakpoint.PHONE, { maxWidth: breakpoints.PHONE, minWidth: 0 }],
  [Breakpoint.TABLET, { maxWidth: breakpoints.TABLET, minWidth: breakpoints.PHONE + 1 }],
  [Breakpoint.DESKTOP, { maxWidth: breakpoints.DESKTOP, minWidth: breakpoints.TABLET + 1 }],
  [Breakpoint.WIDE, { maxWidth: breakpoints.WIDE, minWidth: breakpoints.DESKTOP + 1 }],
]);

export const generateMediaQuery = (breakpoint: Breakpoint, { maxOnly, minOnly }: QueryOptions = {}) => {
  const mediaQuerySettings = breakpointQuerySettingsMap.get(breakpoint);

  if (!mediaQuerySettings) {
    throw new Error('Invalid media query breakpoint name');
  }

  if (maxOnly && minOnly) {
    throw new Error("Media query can't be created with maxOnly and minOnly options at the same time");
  }

  const maxQueryPart = minOnly ? undefined : `(max-width: ${mediaQuerySettings.maxWidth}px)`;
  const minQueryPart = maxOnly ? undefined : `(min-width: ${mediaQuerySettings.minWidth}px)`;

  return `${minQueryPart || ''}${maxQueryPart && minQueryPart ? ' and ' : ''}${maxQueryPart || ''}`;
};
